import React from 'react'

interface PersonIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PersonIcon: React.FC<PersonIconProps> = ({
  color = '#000',
  gradient,
  width = 16,
  height = 19,
  alt = 'Person icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 16 19'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <g
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        clipPath='url(#clip0_2032_478)'
        clipRule='evenodd'
      >
        <path d='M5.501 6.917c.66.666 1.436.989 2.388.989a3.24 3.24 0 002.38-.98c.663-.657.984-1.426.984-2.34 0-.912-.321-1.681-.985-2.338l-.009-.009c-.66-.668-1.438-.989-2.37-.989-.953 0-1.735.324-2.397.98-.663.657-.984 1.426-.984 2.339 0 .912.32 1.682.984 2.339l.01.009zm5.647-5.557C10.251.453 9.153 0 7.889 0 6.608 0 5.51.453 4.612 1.342c-.897.888-1.354 1.976-1.354 3.227 0 1.25.457 2.338 1.354 3.227.898.906 1.996 1.36 3.277 1.36a4.488 4.488 0 003.259-1.342c.897-.888 1.355-1.976 1.355-3.227s-.458-2.339-1.355-3.227zM.201 13.416c-.088.404-.125.79-.16 1.16l-.004.037c-.019.362-.037.743-.037 1.124 0 .997.311 1.795.952 2.393.622.58 1.446.888 2.435.888h9.245c.988 0 1.812-.29 2.434-.888.623-.598.952-1.396.952-2.393-.006-.126-.01-.251-.014-.376-.008-.254-.016-.505-.04-.748a9.654 9.654 0 00-.147-1.197 7.857 7.857 0 00-.311-1.215 4.675 4.675 0 00-.495-1.123 4.634 4.634 0 00-.75-.98 3.396 3.396 0 00-1.08-.67 3.87 3.87 0 00-1.391-.254c-.202 0-.385.072-.751.308-.183.136-.403.271-.64.417l-.147.09c-.257.164-.586.309-1.007.454-.421.127-.824.2-1.245.2-.403 0-.824-.073-1.245-.2-.403-.145-.75-.29-1.007-.453-.293-.182-.549-.345-.787-.508-.366-.236-.55-.308-.75-.308-.495 0-.97.09-1.392.254a3.857 3.857 0 00-1.08.67c-.274.272-.53.599-.75.98A5.532 5.532 0 00.494 12.2c-.128.381-.22.78-.293 1.215zm1.875-1.722a4.3 4.3 0 00-.38.854l-.008.026-.009.026a6.64 6.64 0 00-.245 1.024l-.005.03-.007.03c-.07.32-.101.634-.138 1.012v.008c-.018.354-.034.697-.034 1.033 0 .712.21 1.156.555 1.479.361.337.867.552 1.582.552h9.245c.732 0 1.223-.207 1.568-.54.346-.332.563-.784.568-1.464-.006-.124-.01-.246-.013-.358V15.4a9.91 9.91 0 00-.035-.663l-.004-.032-.001-.033a8.456 8.456 0 00-.13-1.04v-.01a6.617 6.617 0 00-.264-1.023l-.009-.026-.007-.026c-.08-.275-.2-.554-.363-.823l-.007-.011-.006-.012a3.393 3.393 0 00-.533-.7 2.153 2.153 0 00-.667-.409 2.595 2.595 0 00-.837-.167h-.002c-.035.02-.082.048-.144.087-.218.159-.462.309-.67.437l-.023.014-.655-1.065.655 1.065-.137.085c-.373.236-.804.417-1.264.576l-.023.008-.023.007A5.496 5.496 0 018 11.892c-.55 0-1.094-.098-1.606-.252l-.031-.01-.031-.011c-.412-.148-.868-.33-1.248-.57-.29-.18-.559-.35-.814-.525a3.11 3.11 0 00-.16-.097l-.002-.001c-.302.01-.584.07-.828.164-.246.1-.481.248-.689.425-.184.186-.36.412-.515.679z'></path>
      </g>
      <defs>
        <clipPath id='clip0_2032_478'>
          <path fill='#fff' d='M0 0H16V19H0z'></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default PersonIcon
